import { uniq } from 'lodash-es'
import { useSubcategories } from './use-subcategories'

export function useSubcategoriesPhases() {
  const subcategories = useSubcategories()
  const uniquePhases = uniq(subcategories.map((subcategory) => subcategory.metadata.phase.label))
  return uniquePhases
}
